<div
  [formGroup]="searchForm"
  class="filters-container"
  fxLayout="row"
  fxLayout.xs="column"
  fxLayout.sm="column"
  fxLayoutGap="5px"
  fxLayoutGap.xs="5px"
  fxFlexAlign="center center"
  *ngIf="display()"
>
  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutGap="5px"
    fxLayoutGap.xs="5px"
    fxFlexAlign="center center"
  >
    <!-- Lista de Mis Cursos -->
    <!-- <input formControlName="course" type="text" [matAutocomplete]="courseSelect"
      placeholder="{{ 'FILTERS.MY_COURSES' | translate }}"
      [class.valid-selected]="searchForm.get('course').valid && searchForm.get('course').dirty">
    <mat-autocomplete #courseSelect="matAutocomplete" [displayWith]="displayCourse">
      <mat-option *ngFor="let course of filteredCourses | async" [value]="course">
        <span>{{course.name}}</span>
      </mat-option>
    </mat-autocomplete> -->

    <!-- Lista de Todas las Castegorias -->
    <!-- <input
      formControlName="country"
      type="text"
      [matAutocomplete]="countrySelect"
      placeholder="{{ 'FILTERS.COUNTRY' | translate }}"
      [class.valid-selected]="
        searchForm.get('country').valid && searchForm.get('country').dirty
      "
    />
    <mat-autocomplete
      #countrySelect="matAutocomplete"
      [displayWith]="displayCountries"
      
    >
      <mat-option *ngFor="let country of filteredCountries" [value]="country">
        {{ country.name }}
      </mat-option>
    </mat-autocomplete> -->
    <input
      formControlName="category"
      type="text"
      [matAutocomplete]="categoryLevelSelect"
      placeholder="{{ tagtag ==''? tagtag : 'FILTERS.LEVEL'|translate }}"
      [class.valid-selected]="
        searchForm.get('category').valid && searchForm.get('category').dirty
      "
    />
    <mat-autocomplete
      #categoryLevelSelect="matAutocomplete"
      [displayWith]="displayLevel"
 
    >
      <mat-option *ngFor="let category of filteredLevel" [value]="category">
        {{ category.name }}
      </mat-option>
    </mat-autocomplete>
    <input
      formControlName="category1"
      type="text"
      [matAutocomplete]="categoryLessonSelect"
      placeholder="{{ tagtag1 ==''? tagtag1 : 'FILTERS.LESSON' | translate }}"
      [class.valid-selected]="
        searchForm.get('category1').valid && searchForm.get('category1').dirty
      "
    />
    <mat-autocomplete
      #categoryLessonSelect="matAutocomplete"
      [displayWith]="displayLesson"
    >
      <mat-option *ngFor="let category1 of filteredLesson" [value]="category1">
        {{ category1.name }}
      </mat-option>
    </mat-autocomplete>
    <!-- <input
      formControlName="category2"
      type="text"
      [matAutocomplete]="categorySelect"
      placeholder="{{ tagtag2 ==''? tagtag2 : 'FILTERS.OA' | translate}}"
      [class.valid-selected]="
        searchForm.get('category2').valid && searchForm.get('category2').dirty
      "
    />
    <mat-autocomplete
      #categorySelect="matAutocomplete"
      [displayWith]="displayCategory"
    >
      <mat-option
        *ngFor="let category2 of filteredCategories2"
        [value]="category2"
      >
        {{ category2.name }}
      </mat-option>
    </mat-autocomplete> -->

    <input
      formControlName="category3"
      type="text"
      [matAutocomplete]="categoryExtraSelect"
      placeholder="{{ tagtag3 ==''? tagtag3 : 'FILTERS.EXTRA' | translate }}"
      [class.valid-selected]="
        searchForm.get('category3').valid && searchForm.get('category3').dirty
      "
    />
    <mat-autocomplete
      #categoryExtraSelect="matAutocomplete"
      [displayWith]="displayExtrastags"
    >
      <mat-option *ngFor="let category3 of filteredextra" [value]="category3">
        {{ category3.name }}
      </mat-option>
    </mat-autocomplete>

    <!-- Botón de busqueda y filtrado -->
    <button
      mat-flat-button
      color="accent"
      (click)="setSearch()"
      [disabled]="
      disabledBotton()
      "
    >
      <mat-icon>search</mat-icon>
    </button>
  </div>

  <!-- Input de Busqueda -->
  <!-- <div fxLayout="row" fxLayoutGap="5px" fxFlexAlign="center center">
    <input formControlName="search" type="text" placeholder="{{ 'FILTERS.SEARCH' | translate }}"
      [class.valid-selected]="searchForm.get('search').valid && searchForm.get('search').dirty">
    <button mat-flat-button color="accent" (click)=setSearch() [disabled]="searchForm.invalid">
      <mat-icon>search</mat-icon>
    </button>
  </div> -->
</div>
